import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import {
  CardResultBody,
  CardResultHeader,
  ContainerCardResult,
  InfoResults,
  SubDesc,
} from "./CardResult.styled";

import { Avatar } from "@mui/material";
import { H2 } from "../UI/generalLayout/Layout.styled";
import moment from "moment-timezone";

import { useState, useEffect } from "react";
import useFetchPhoto from "../../hooks/useFetchPhoto";
import { dateToBrazilianHour } from "../../utils/date.utils";

interface ICardResult {
  render: string;
  horario: string;
  foto?: any;
  nomeMedico?: string;
  titulo: string;
  unidade?: string;
  onClick: (id: string) => void;
  id: string;
}

const CardResult = ({
  render,
  horario,
  foto,
  nomeMedico,
  titulo,
  unidade,
  onClick,
  id,
}: ICardResult) => {
  const [isNextConsult, setNextConsult] = useState(false);
  const [photo, setPhoto] = useState<any>();

  useFetchPhoto(foto, setPhoto);

  // Data formatada
  const date = moment.utc(horario).format("DD/MM/YYYY");

  // Data formatada para comparação
  const today = moment().format("YYYY-MM-DDTHH:mm");
  const dateComp = moment.utc(horario).format("YYYY-MM-DDTHH:mm");

  const verifyDate = () => {
    if (moment(dateComp).isAfter(today)) {
      setNextConsult(true);
    }
  };

  useEffect(() => {
    verifyDate();
  }, [verifyDate]);

  return (
    <>
      {render === "CC" && (
        <>
          <ContainerCardResult render={render}>
            <CardResultHeader>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <CalendarMonthOutlinedIcon style={{ fontSize: "18px" }} />
                <p style={{ margin: 0 }}>{date}</p>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "6px", marginLeft: "12px" }}>
                <AccessTimeOutlinedIcon style={{ fontSize: "18px" }} />
                <p style={{ margin: 0 }}>{dateToBrazilianHour(horario)}</p>
              </div>
            </CardResultHeader>
            <CardResultBody position={1} style={{ alignItems: "center", width: "calc(100% - 32px)" }}>
              <Avatar
                src={photo}
                style={{ 
                  height: "48px", 
                  width: "48px", 
                  minWidth: "48px", 
                  minHeight: "48px", 
                  borderRadius: "10px", 
                  flexShrink: 0,
                  border: "1px solid #E2E8F0"
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "12px",
                  justifyContent: "center",
                  overflow: "hidden",
                  width: "100%"
                }}
              >
                <H2 style={{ 
                  margin: "0px", 
                  fontSize: "14px", 
                  fontWeight: 600, 
                  lineHeight: "18px", 
                  color: "#0F172A",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}>
                  {nomeMedico}
                </H2>
                <SubDesc style={{ fontSize: "12.5px", color: "#0284C7", fontWeight: 500, marginTop: "2px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {titulo}
                </SubDesc>
                {unidade && (
                  <SubDesc style={{ fontSize: "12px", color: "#64748B", marginTop: "1px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    📍 {unidade}
                  </SubDesc>
                )}
              </div>
            </CardResultBody>
            <InfoResults
              isLastConsult={isNextConsult}
              render={render}
              onClick={() => onClick(id)}
            >
              <p style={{ margin: 0, fontWeight: 500 }}>Informações da consulta</p>
              <KeyboardArrowRightIcon />
            </InfoResults>
          </ContainerCardResult>
        </>
      )}
      {render === "CE" && (
        <>
          <ContainerCardResult render={render} onClick={() => onClick(id)} style={{ cursor: 'pointer'}}>
            <CardResultHeader>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <CalendarMonthOutlinedIcon style={{ fontSize: "18px" }} />
                <p style={{ margin: 0 }}>{date}</p>
              </div>
            </CardResultHeader>
            <CardResultBody position={1}>
              <Avatar
                style={{ 
                  height: "46px", 
                  width: "46px", 
                  minWidth: "46px", 
                  minHeight: "46px", 
                  borderRadius: "10px", 
                  backgroundColor: "rgba(10, 81, 144, 0.1)", 
                  color: "#0a5190",
                  flexShrink: 0
                }}
              >
                <ScienceOutlinedIcon style={{ fontSize: "24px" }} />
              </Avatar>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "12px",
                  justifyContent: "center",
                  overflow: "hidden",
                  width: "100%"
                }}
              >
                <H2 style={{ 
                  margin: "0px", 
                  fontSize: "14px", 
                  fontWeight: 600, 
                  lineHeight: "18px", 
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                  whiteSpace: "normal"
                }}>
                  {titulo}
                </H2>
                <SubDesc style={{ marginTop: "2px" }}>Laudo de exame disponível</SubDesc>
              </div>
            </CardResultBody>
            <InfoResults isLastConsult={isNextConsult} render={render}>
              <p style={{ margin: 0 }}>Resultado do Exame</p>
              <KeyboardArrowRightIcon />
            </InfoResults>
          </ContainerCardResult>
        </>
      )}
    </>
  );
};

export default CardResult;
